import React from 'react'
import PropTypes from 'prop-types'
import {customIcon} from '../shared/styles'

const EntitlementIcon = ({size}) => {
    const {container, content} = customIcon(size, '#2D72C4')

    return (
        <div style={container}>
            <div style={{width: content.fontSize, height: content.fontSize}}>
                <i data-testid="mi" className="fa fa-shield" style={content} />
            </div>
        </div>
    )
}

EntitlementIcon.propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large', 'x-large']).isRequired
}

export default EntitlementIcon
